import React, { useState } from "react";
import axios from "axios";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";

const AddSchedulerInfo = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // State to hold form data
  const [formData, setFormData] = useState({
    catalogid: "",
    name: "",
    starttime: "",
    endtime: "",
    remark: "",
    active: true,
  });

  // State to hold API response or error
  const [message, setMessage] = useState("");
  const [catalogs, setCatalogs] = useState([]);
  const [timeError, setTimeError] = useState("");

  // Fetch catalogs on component mount
  React.useEffect(() => {
    fetchCatalogs();
  }, []);

  const fetchCatalogs = async () => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId");
      return;
    }

    try {
      const response = await axios.get(
        'https://api.dqr-display-tms.bonrix.in/api/CatalogOperation/SubUser/GetDistinct/catalogname',
        {
          headers: {
            'accept': 'text/plain',
            'UserId': userid,
            'X-Authorization': token
          }
        }
      );

      if (response.data && response.data.data && Array.isArray(response.data.data)) {
        setCatalogs(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching Catalogues:", error);
    }
  };

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "starttime") {
      // Clear endtime when starttime changes
      setFormData(prev => ({
        ...prev,
        [name]: value,
        endtime: ""
      }));
      setTimeError("");
    } else if (name === "endtime") {
      // Validate endtime against starttime
      if (formData.starttime && value) {
        if (value <= formData.starttime) {
          setTimeError("End Time must be greater than Start Time");
        } else {
          setTimeError("");
        }
      }
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the form from refreshing the page

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    if (!formData.catalogid) {
      setMessage("Please select a Catalogue");
      return;
    }

    if (!formData.starttime || !formData.endtime) {
      setMessage("Please select both start and end times");
      return;
    }

    if (formData.endtime <= formData.starttime) {
      setTimeError("End Time must be greater than Start Time");
      return;
    }

    const dataToSend = {
      catalogid: parseInt(formData.catalogid),
      schedulerid: parseInt(id),
      name: formData.name,
      remark: formData.remark,
      active: formData.active,
      starttime: formData.starttime,
      endtime: formData.endtime
    };

    try {
      const response = await axios.post(
        'https://api.dqr-display-tms.bonrix.in/api/CatalogSchedulerInfoOperation/SubUser/Insert',
        dataToSend,
        {
          headers: {
            "X-Authorization": token,
            "UserId": userid,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && response.data.isresponse) {
        setMessage("Scheduler info added successfully!");
        setTimeout(() => {
          navigate(`/showschedule/${id}/Schedule`);
        }, 3000);
      } else {
        setMessage(response.data?.errormsg || "Failed to add scheduler info");
      }
    } catch (error) {
      console.error("Error adding schedule info:", error);
      setMessage(error.response?.data?.message || "Failed to add scheduler info");
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Add Scheduler Info</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Catalogue</label>
                              <select 
                                className="form-control" 
                                name="catalogid" 
                                value={formData.catalogid}
                                onChange={handleChange}
                                required
                              >
                                <option value="">Select Catalogue...</option>
                                {catalogs.map((catalog) => (
                                  <option key={catalog.id} value={catalog.id}>
                                    {catalog.value}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter name"
                                name="name"
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Start Time</label>
                              <input
                                type="time"
                                className="form-control"
                                value={formData.starttime}
                                onChange={handleChange}
                                name="starttime"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>End Time</label>
                              <input
                                type="time"
                                className="form-control"
                                value={formData.endtime}
                                onChange={handleChange}
                                name="endtime"
                                required
                                min={formData.starttime || ""}
                                disabled={!formData.starttime}
                              />
                              {timeError && (
                                <div className="text-danger mt-1">
                                  <small>{timeError}</small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Active</label>
                              <select 
                                className="form-control" 
                                name="active" 
                                value={formData.active}
                                onChange={handleChange}
                              >
                                <option value={true}>Active</option>
                                <option value={false}>Deactive</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Remark</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.remark}
                                onChange={handleChange}
                                placeholder="Enter remark"
                                name="remark"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info"
                          >
                            Add
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message && message.includes("successfully") ? (
        <SuccessMessage message={message} />
      ) : message ? (
        <FailedMessage message={message} />
      ) : (
        ""
      )}
    </>
  );
};

export default AddSchedulerInfo;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
